// Re-export everything from @material-ui/core (v4), replacing Dialog.
export * from '@material-ui/core-lib';
import { Dialog as DialogBase } from '@material-ui/core-lib';
import { createStackedDialog } from '../components/stackedDialogWrapper';
export const Dialog = createStackedDialog(DialogBase);
